import {
  ADICIONAR_MENSAGEM,
  FECHAR_MENSAGEM,
} from "./actions";


const initialState = {
  mensagens: { exibir: false },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ADICIONAR_MENSAGEM:
      return { ...state, mensagens: { ...action.mensagem, exibir: true } };
    case FECHAR_MENSAGEM:
      return { ...state, mensagens: { exibir: false } };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/componentes/mensagem/reducers.js